import * as Sentry from '@sentry/react';

import { setWindowLocation } from 'utils/setWindowLocation';

import { getVisitorUrl } from './getVisitorUrl';

export const redirectToVisitor = (region: OP.Env, orgId?: number | null) => {
  if (!orgId) {
    Sentry.captureMessage('No orgId provided to redirectToVisitor', {
      contexts: {
        debugInfo: {
          location: JSON.stringify(window.location),
          region,
        },
      },
    });
  }
  setWindowLocation(`${getVisitorUrl(region)}/o/${orgId}/dashboard`);
};
